
export default function keyboard() {

    const STATUS = 0, DATA = 1;

    let hasData = false;
    let data = 0;

    return {
        read(address) {
            if (address == STATUS) {
                return hasData ? 0x80 : 0x00;
            } else {
                hasData = false;
                return data;
            }
        },

        write(address, value) {
        },

        feed(d) {
            if (hasData) {
                console.log("keyboard data dropped: ", d);
                return;
            }
            data = d;
            hasData = true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/emu/keyboard.js